<template>
	<div class="carousel-manager">
		<el-form :inline="true">
			<el-form-item>
				<toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
			</el-form-item>
		</el-form>
		
		<!-- 轮播图列表 -->
		<el-table
				:data="carouselList"
				border
				stripe
				@current-change="selectCurrentRow"
				style="width: 100%; margin-top: 20px"
		>
			<el-table-column prop="title" label="轮播图名称" min-width="150" header-align="center" align="center"/>
			<el-table-column prop="coverPhotoUrl" label="图片" min-width="120" header-align="center" align="center">
				<template #default="scope">
					<el-image
							v-if="scope.row.coverPhotoUrl"
							:src="scope.row.coverPhotoUrl"
							fit="cover"
							style="width: 80px; height: 40px"
					/>
					<span v-else>-</span>
				</template>
			</el-table-column>
			<el-table-column prop="linkUrl" label="链接地址" min-width="120" header-align="center" align="center"/>
			<el-table-column prop="updateUserName" label="修改人" header-align="center" align="center"/>
			<el-table-column prop="updateTime" label="修改时间" width="180" header-align="center" align="center"/>
			<el-table-column prop="enableTime" label="启用时间" width="180" header-align="center" align="center"/>
			<el-table-column prop="isEnable" label="状态" width="100" header-align="center" align="center">
				<template #default="scope">
					<el-tag :type="scope.row.isEnable ? 'success' : 'danger'">
						{{ scope.row.isEnable ? '启用' : '禁用' }}
					</el-tag>
				</template>
			</el-table-column>
<!--			<el-table-column label="操作" width="120">-->
<!--				<template #default="scope">-->
<!--					<el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>-->
<!--				</template>-->
<!--			</el-table-column>-->
		</el-table>
		
		<!-- 新增/编辑轮播图弹窗 -->
		<el-dialog
				:title="dialogTitle"
				:visible.sync="dialogVisible"
				v-model="dialogVisible"
				width="50%"
				destroy-on-close
				:close-on-click-modal="false"
		>
			<el-form
					:model="formData"
					:rules="formRules"
					ref="formRef"
					label-width="120px"
			>
				<el-form-item label="轮播图名称" prop="title">
					<el-input style="width: 60%" v-model="formData.title" placeholder="请输入轮播图名称" />
				</el-form-item>
				<el-form-item label="链接地址" prop="linkUrl">
					<el-input style="width: 60%" v-model="formData.linkUrl" placeholder="请输入链接地址" />
				</el-form-item>
				<el-form-item label="排序序号" prop="sortNo">
					<el-input
							v-model.number="formData.sortNo"
							type="number"
							placeholder="请输入排序序号"
							min="1"
					/>
				</el-form-item>
<!--				<el-form-item label="启用状态" prop="isEnable">-->
<!--					<el-switch-->
<!--							v-model="formData.isEnable"-->
<!--							active-text="启用"-->
<!--							inactive-text="禁用"-->
<!--					/>-->
<!--				</el-form-item>-->
				<el-form-item label="图片">
					<el-upload
							class="avatar-uploader"
							:action="uploadUrl"
							:headers="headers"
							:show-file-list="false"
							:on-success="handleImageSuccess"
							:before-upload="beforeUpload"
					>
						<img
								v-if="formData.coverPhotoUrl"
								:src="formData.coverPhotoUrl"
								class="avatar"
								alt="轮播图"
						/>
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					<el-button
							v-if="formData.coverPhotoUrl"
							type="text"
							style="color: red; margin-top: 5px"
							@click="formData.coverPhotoUrl = ''"
					>
						替换图片
					</el-button>
				</el-form-item>
			</el-form>
			<template #footer>
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="handleSave">保存</el-button>
			</template>
		</el-dialog>
	</div>
</template>

<script>
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import {
	addCarouselInformation, deleteCarouselInformation,
	getCarouselInformationList,
	updateCarouselInformation, updateCarouselInformationIsEnable,
	uploadCarouselAndMessage
} from "../../api/api";
export default {
	components: { Toolbar },
	name: "CarouselManager",
	data() {
		return {
			buttonList: [],
			// 轮播图列表数据
			carouselList: [],
			// 弹窗相关
			dialogVisible: false,
			dialogTitle: "",
			formRef: null,
			// 表单数据（适配新参数）
			formData: {
				id: "",
				title: "",
				coverPhotoUrl: "",
				linkUrl: "",
				isEnable: false, // 启用标识默认禁用
				sortNo: 1 // 排序序号默认1
			},
			// 表单校验规则
			formRules: {
				title: [{ required: true, message: "请输入轮播图名称", trigger: "blur" }],
				linkUrl: [{ required: true, message: "请输入链接地址", trigger: "blur" }],
				sortNo: [
					{ required: true, message: "请输入排序序号", trigger: "blur" },
					{ type: "number", message: "排序序号必须为数字", trigger: "blur" },
				]
			},
			// 图片上传地址
			uploadUrl: "",
			filters: {
				title: undefined,
			},
			needData:undefined,
		};
	},
	computed: {
		headers () {
			return {
				'Authorization': 'Bearer ' + this.getToken() // 直接从本地获取token就行
			}
		},
	},
	methods: {
		//启用
		enable(){
			if (!this.needData) {
				this.$message.error("请选择要启用的一行数据！");
				return;
			}
			console.log("enable",'启用')
			this.$confirm("此操作将启用该轮播图, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					// 启用
					let params = {
						id: this.needData.id,
						isEnable: true,
					}
					updateCarouselInformationIsEnable(params).then((res) => {
						if (res.data.success){
							this.$message.success("启用成功");
							this.getCarouselInformationList();
						}else{
							this.$message.error(res.data.message);
						}
					});
				})
		},
		//禁用
		disabled(){
			
			console.log("disabled",'禁用')
			if (!this.needData) {
				this.$message.error("请选择要禁用的一行数据！");
				return;
			}
			this.$confirm("此操作将禁用该轮播图, 是否继续?", "提示", {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							type: "warning"
						})
						.then(() => {
							// 禁用
							let params = {
								id: this.needData.id,
								isEnable: false,
							}
							updateCarouselInformationIsEnable(params).then((res) => {
								if (res.data.success){
									this.$message.success("禁用成功");
									this.getCarouselInformationList();
								}else{
									this.$message.error(res.data.message);
								}
							});
						})
		
		},
		selectCurrentRow(val) {
			this.needData = val;
		},
		// 获取token
		getToken () {
			return localStorage.getItem('Token')
		},
		// 查询轮播图列表
		getCarouselInformationList() {
			let params = {
				title: this.filters.title,
			};
			getCarouselInformationList(params).then((res) => {
				this.carouselList = res.data.response;
			});
		},
		callFunction(item) {
			this[item.func].apply(this, item);
		},
		// 新增轮播图
		handleAdd() {
			this.dialogTitle = "新增轮播图";
			// 重置表单
			this.resetForm();
			this.dialogVisible = true;
		},
		// 编辑轮播图
		handleEdit() {
			if (!this.needData){
				this.$message.error("请选择要编辑的一行数据！");
				return;
			}
			this.dialogTitle = "编辑轮播图";
			// 复制行数据到表单（适配新字段）
			this.formData = { ...this.needData };
			this.dialogVisible = true;
		},
		// 选择当前行数据 删除轮播图
		handleDel() {
			if (!this.needData){
				this.$message.error("请选择要删除的一行数据！");
				return;
			}
			this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					// 删除
					let params = {
						id: this.needData.id
					}
					deleteCarouselInformation(params).then((res) => {
						if (res.data.success){
							this.$message.success("删除成功");
							this.getCarouselInformationList();
						}else{
							this.$message.error(res.data.message);
						}
					});
				})
		},
		// 重置表单
		resetForm() {
			this.formData = {
				id: "",
				title: "",
				coverPhotoUrl: "",
				linkUrl: "",
				isEnable: false,
				sortNo: 1
			};
			if (this.formRef) {
				this.formRef.resetFields();
			}
		},
		// 保存轮播图
		handleSave() {
			this.$refs.formRef.validate((valid) => {
				if (valid) {
					const newItem = {
						...this.formData,
						
					};
					// 编辑：更新列表数据
					if (this.formData.id) {
						updateCarouselInformation(newItem).then((res) => {
							if (res.data.success){
								this.$message.success("修改成功");
								this.getCarouselInformationList();
								// 关闭弹窗
								this.dialogVisible = false;
							}else{
								this.$message.error(res.data.message);
							}
						});
					} else {
						// 新增：添加到列表
						
						addCarouselInformation(newItem).then((res) => {
							if (res.data.success){
								this.$message.success(res.data.message);
								this.getCarouselInformationList();
								// 关闭弹窗
								this.dialogVisible = false;
							}else{
								this.$message.error(res.data.message);
							}
						});
					}
					
				}
			});
		},
		// 图片上传成功回调（适配coverPhotoUrl）
		handleImageSuccess(res) {
			if (res.success){
				this.formData.coverPhotoUrl = res.response.weburl || "";
			}
		},
		// 图片上传前校验
		beforeUpload(file) {
			// 限制图片格式和大小
			const isImage = file.type.startsWith("image/");
			const isLt2M = file.size / 1024 / 1024 < 2;
			
			if (!isImage) {
				this.$message.error("上传文件只能是图片格式!");
			}
			if (!isLt2M) {
				this.$message.error("上传图片大小不能超过 2MB!");
			}
			return isImage && isLt2M;
		},
	},
	mounted() {
		let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
		this.buttonList = getButtonList(this.$route.path, routers);
		this.uploadUrl = uploadCarouselAndMessage;
		this.getCarouselInformationList();
	}
};
</script>

<style scoped>
.carousel-manager {
	padding: 20px;
}

.header {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.avatar-uploader {
	width: 178px;
	height: 178px;
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c8c8c;
	width: 178px;
	height: 178px;
	line-height: 178px;
	text-align: center;
}

.avatar {
	width: 178px;
	height: 178px;
	display: block;
}
</style>